import { combineReducers } from 'redux';

import MasterRoster from './masterroster/reducer';

export default combineReducers({
  MasterRoster,
});



// WEBPACK FOOTER //
// ./src/pages/masterroster/state/reducer.js